import { useT } from '@mrkt/features/i18n'; // used to share labels between old and new footer. should be deleted along with old footer

export var useFooterLabels = function useFooterLabels() {
  var t = useT();
  return {
    googlePlay: t('FRODOR_S4A_GOOGLE_PLAY', 'Get it on Google Play', 'Link to download Spotify for Artists Android app'),
    appStore: t('FRODOR_S4A_APP_STORE', 'Download on the App Store', 'Link to download Spotify for Artists iOS app')
  };
};